import { GenericTable } from "@shared/components/GenericTable";
import { useCurrency } from "@shared/selectors/globalSelectors";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import React from "react";

interface PerformanceTablesProps {
  performanceData: any;
}

export const PerformanceTables: React.FC<PerformanceTablesProps> = ({
  performanceData,
}) => {
  const currency = useCurrency();
  const performanceHistoryColumns = [
    {
      key: "month",
      header: "Month",
      sortable: true,
      headerTooltip: "The month the performance data was recorded for.",
    },
    {
      key: "performanceIndex",
      header: "Performance Index",
      sortable: true,
      headerTooltip:
        "A single score representing the overall operational effectiveness of this asset, combining reliability, availability, and efficiency.",
    },
    {
      key: "totalUptime",
      header: "Uptime %",
      sortable: true,
      render: (value) => `${value}%`,
      headerTooltip:
        "The percentage of time this asset has been operational and available as scheduled during the selected period.",
    },
    {
      key: "totalCost",
      header: `Cost (${currency})`,
      sortable: true,
      render: (value) => `${currency} ${value?.toLocaleString()}`,
    },
  ];

  return (
    <div className="space-y-6">
      {/* Performance History Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            Performance History
            <Badge variant="outline" className="text-xs">
              Last 6 Months
            </Badge>
          </CardTitle>
          <p className="text-sm text-gray-600">
            Historical performance data for this asset.
          </p>
        </CardHeader>
        <CardContent>
          <GenericTable
            data={performanceData ?? []}
            columns={performanceHistoryColumns}
            rowKey="month"
            emptyMessage="No performance history available"
          />
        </CardContent>
      </Card>
    </div>
  );
};
